//#region src/printer_cover_state.ts
var PrinterCoverState = /* @__PURE__ */ function(PrinterCoverState) {
	PrinterCoverState[PrinterCoverState["Closed"] = 0] = "Closed";
	PrinterCoverState[PrinterCoverState["Open"] = 1] = "Open";
	return PrinterCoverState;
}(PrinterCoverState || {});
//#endregion
export { PrinterCoverState };

//# sourceMappingURL=printer_cover_state.js.map